import {
  CircularProgress,
} from '@mui/material';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './OverlayMaskLoader.scss';

const defaultProps = {
  show: false,
  loadingMessage: null,
  blockedScreen: true,
};

export default function OverlayMaskLoader(props) {
  const { show, blockedScreen, loadingMessage } = { ...defaultProps, ...filterUndefined(props) };
  return (
    show ? (
      <div className='overlay-mask-loader-component'>
        {blockedScreen && (
          <div className='overlay-mask-loader' />
        )}

        {loadingMessage
          ? (
            <div className='overlay-mask-loading-message'>
              <CircularProgress className='overlay-mask-loading-icon' size={30} />
              <div className='overlay-mask-loading-text' data-private>{loadingMessage}</div>
            </div>
          ) : ''}
      </div>
    ) : ''
  );
}
